/*
* @author  Agence Dn'D <contact@dnd.fr>
* @license https://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
* @link    https://www.dnd.fr/
*/

document.addEventListener('DOMContentLoaded', () => {
    const roomvoContainers = document.querySelectorAll('.roomvo-container');

    if (!roomvoContainers.length) return;

    document.addEventListener('on:variant:change', (event) => {
        const { variant } = event.detail;
        if (!variant || !variant.sku) return;

        roomvoContainers.forEach((container) => {
            container.setAttribute('data-sku', variant.sku);
        });
    });
});